// A call the backend won't answer for the login that made it (one without trading access, say) fails
// with org.eggs.error.not_authorized and the message for the member as its first argument.
// Production's backend sends it wrapped in a runtime error, the refusal and its arguments in one
// string:
//   [8, 48, <request>, {}, "wamp.error.runtime_error",
//    ["org.eggs.error.not_authorized: [\"Trading access is required for this report. Call ECI at (800) 872-3324.\"]"]]
// Both shapes are read here. So is the router's own refusal (wamp.error.not_authorized: its policy
// doesn't let the login make that call), with FALLBACK in place of its text, which isn't written
// for members. A refusal isn't worth trying again: the same login gets the same answer.
// No Angular here, so Node can test it (charts/notAuthorized.test.mjs). React has the same rules in
// react/src/services/notAuthorized.ts: change both.

const NOT_AUTHORIZED = 'org.eggs.error.not_authorized';
const ROUTER_NOT_AUTHORIZED = 'wamp.error.not_authorized';

// A phone number in the message stays on one line: "(800) 872-3324" breaks at neither its space nor
// its hyphen (a no-break space and a non-breaking hyphen).
const PHONE = /\(?\d{3}\)?[ -]?\d{3}-\d{4}/g;

function text(value) {
  return typeof value === 'string' && value.trim()
    ? value.trim().replace(PHONE, number => number.replace(/ /g, '\u00a0').replace(/-/g, '\u2011'))
    : null;
}

export const FALLBACK = text("You don't have access to this. Call ECI at (800) 872-3324.");

/**
 * The message to show for a call that was refused as not authorized, or null when `err` is any other
 * failure. `err` as thruway.js fails a call with: a WampErrorException, {errorUri, args}.
 * @param {*} err
 * @returns {string|null}
 */
export function notAuthorizedMessage(err) {
  if (!err || typeof err !== 'object') {
    return null;
  }
  const args = Array.isArray(err.args) ? err.args : [];
  if (err.errorUri === NOT_AUTHORIZED) {
    return text(args[0]) || FALLBACK;
  }
  if (err.errorUri === ROUTER_NOT_AUTHORIZED) {
    return FALLBACK;
  }
  // Wrapped: the URI alone, or the URI, ": " and its arguments as JSON.
  const wrapped = typeof args[0] === 'string' ? args[0].trim() : '';
  if (wrapped === NOT_AUTHORIZED) {
    return FALLBACK;
  }
  if (wrapped.indexOf(NOT_AUTHORIZED + ':') !== 0) {
    return null;
  }
  try {
    const inner = JSON.parse(wrapped.slice(NOT_AUTHORIZED.length + 1));
    return text(Array.isArray(inner) ? inner[0] : inner) || FALLBACK;
  } catch (e) {
    return FALLBACK;
  }
}
